import apiClient from "../baseUrl/axiosConfig";

// Fetches the admin-configured registration fields and performance type options.
export const getRegistrationForm = async () => {
  const response = await apiClient.get("/voice-talents/form");
  return response.data;
};
